// src/ContactForm.jsx
import React, { useState } from 'react';
import styles from '../css/modules/ContactForm.module.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ContactForm = () => {
  const [formData, setFormData] = useState({
    email: '',
    telephone: '',
    title: '',
    content: '',
  });
  const [loading, setLoading] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState(null);
  // Rozróżniamy potwierdzenie od błędu - wcześniej oba komunikaty miały ten sam
  // kolor, więc "wysłano" i "nie udało się" wyglądały identycznie.
  const [isError, setIsError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Funkcja walidująca poprawność emaila przy użyciu prostego wyrażenia regularnego
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFeedbackMessage(null);
    setIsError(false);

    // Weryfikacja poprawności emaila
    if (!isValidEmail(formData.email)) {
      setIsError(true);
      setFeedbackMessage('Proszę podać poprawny adres e-mail.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/cyber/send_message`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        setIsError(true);
        setFeedbackMessage(data.message || 'Błąd przy wysyłaniu wiadomości.');
      } else {
        setIsError(false);
        setFeedbackMessage('Wiadomość została wysłana. Odpowiemy możliwie najszybciej.');
        setFormData({
          email: '',
          telephone: '',
          title: '',
          content: '',
        });
      }
    } catch (error) {
      setIsError(true);
      setFeedbackMessage('Wystąpił błąd. Spróbuj ponownie.');
    }
    setLoading(false);
  };

  return (
    <main className={styles.contactContainer}>
      <h1 className={styles.contactTitle}>Kontakt - Zeglarka.pl</h1>
      <p className={styles.contactIntro}>
        Masz pytanie o dostęp do testów, płatność albo fakturę? Napisz -
        odpowiadamy zwykle w ciągu jednego dnia roboczego. Możesz też wysłać wiadomość
        bezpośrednio na <a href="mailto:kontakt@zeglarka.pl">kontakt@zeglarka.pl</a>.
      </p>
      <form onSubmit={handleSubmit} className={styles.contactForm}>
        <label htmlFor="kontakt-email">Adres e-mail</label>
        <input
          id="kontakt-email"
          type="email"
          name="email"
          autoComplete="email"
          value={formData.email}
          onChange={handleChange}
          required
        />

        <label htmlFor="kontakt-telefon">Telefon (opcjonalnie)</label>
        <input
          id="kontakt-telefon"
          type="tel"
          name="telephone"
          autoComplete="tel"
          value={formData.telephone}
          onChange={handleChange}
        />

        <label htmlFor="kontakt-tytul">Tytuł</label>
        <input
          id="kontakt-tytul"
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />

        <label htmlFor="kontakt-tresc">Treść wiadomości</label>
        <textarea
          id="kontakt-tresc"
          name="content"
          rows={6}
          value={formData.content}
          onChange={handleChange}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Wysyłanie...' : 'Wyślij'}
        </button>
        {feedbackMessage && (
          <p
            className={isError ? styles.feedbackError : styles.feedbackOk}
            role="alert"
          >
            {feedbackMessage}
          </p>
        )}
      </form>
    </main>
  );
};

export default ContactForm;
